import { Injectable } from '@angular/core';
import { MatrixEvent, MatrixScheduler } from 'matrix-js-sdk';

@Injectable({
  providedIn: 'root'
})
/**
 * Hier werden Methoden aus dem Scheduler überschrieben um damit
 * die Anforderung A_25423 zu erfüllen.
 */
export class SchedulerService {
  /**
   * Hier wird, wie in A_25423 definiert ein Backoff implementiert, welcher exponential versucht Nachrichten
   * erneut zu senden.
   * Maximale Retries: 20
   * @private
   */
  public static RETRY_BACKOFF(): void {
    MatrixScheduler.RETRY_BACKOFF_RATELIMIT = function retryBackoff(
      event: MatrixEvent | null,
      attempts: number
    ): number {
      const maxAttempts = 20;
      const maxTime = 300000;
      if (attempts >= maxAttempts) {
        console.error(`Maximale Anzahl an Versuchen (${maxAttempts}) erreicht.`);
        return -1;
      }
      const delay = Math.pow(2, attempts) * 100;
      const elapsedTime = delay * (attempts + 1);
      if (elapsedTime > maxTime) {
        console.error(`Maximale Zeit (${maxTime / 1000}) Sekunden überschritten`);
        return -1;
      }
      return delay;
    };
  }
}
